import { useAction } from "./useAction";
import { Endereco } from "../interfaces/Endereco";
import { cadastrarEnderecoService } from "../services/cadastrarEnderecoService";

export const useCadastrarEndereco = () => {
  const {
    execute: cadastrarEndereco,
    isLoading,
    data,
    error,
    success,
  } = useAction<Endereco>(cadastrarEnderecoService);

  const handleSubmit = async (cotaUsuario: Endereco) => {
    try {
      const response = await cadastrarEndereco(cotaUsuario);
      console.log("Endereco cadastrada com sucesso", response);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar endereco", error);
      throw error; // propaga erro para quem chamou
    }
  };

  return {
    handleSubmit,
    isLoading,
    data,
    error,
    success,
  };
};
